import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, map, of } from 'rxjs';
import { WordPressPost } from '../services/interfaces/wordpress-post';
import { LanguageService } from './language.service';

@Injectable({
  providedIn: 'root'
})
export class BlogService {
  // URL diretto: evita NG04002 durante SSR (il path /wp-blog-custom veniva interpretato come route)
  private readonly WORDPRESS_URL = 'https://blog.divinea.com/wp-json/custom/v1';
  /** Link relativi (es. /link/<uuid>) altrimenti finiscono nello stesso origin → router Angular → NG04002 */
  private readonly PUBLIC_SITE_ORIGIN = 'https://divinea.com';

  constructor(
    private http: HttpClient,
    private languageService: LanguageService
  ) {}

  /** Assicura href assoluto per <a> e per evitare navigazioni SPA su path WordPress. */
  private normalizePostLink(link: string | undefined): string {
    if (!link?.trim()) {
      return '#';
    }
    const t = link.trim();
    if (/^https?:\/\//i.test(t)) {
      return t;
    }
    return t.startsWith('/') ? `${this.PUBLIC_SITE_ORIGIN}${t}` : `${this.PUBLIC_SITE_ORIGIN}/${t}`;
  }

  getPosts(): Observable<WordPressPost[]> {
    const lang = this.languageService.getCurrentLanguage();
    const url = `${this.WORDPRESS_URL}/posts?lang=${lang}&per_page=3&_t=${Date.now()}`;

    return this.http.get<WordPressPost[]>(url).pipe(
      map((posts) =>
        (posts || []).map((p) => ({
          ...p,
          link: this.normalizePostLink(p.link),
        }))
      ),
      catchError((error) => {
        console.error('Blog posts fetch error:', error);
        return of([]);
      })
    );
  }
}
